<template>
    <LayoutDefault
        variant="white"
        :hide-logo-on-scroll="true"
    >
        <TransitionFade v-if="load" class="absolute top-0 left-0 h-full w-full z-[25]">
            <AtomFullPageLoader variant="black"  v-if="load" />
        </TransitionFade>

        <TransitionFade>
            <div v-if="!load && videos.length">
                <OrganismVideosHero />
                <OrganismVideosProductions />
                <OrganismVideosAllVideos />
            </div>
        </TransitionFade>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismVideosHero from "../components/videos/organisms/OrganismVideosHero.vue";
import OrganismVideosProductions from "../components/videos/organisms/OrganismVideosProductions.vue";
import OrganismVideosAllVideos from "../components/videos/organisms/OrganismVideosAllVideos.vue";
import {mapActions, mapState} from "vuex";
import TransitionFade from "../transitions/TransitionFade.vue";
import AtomLoading from "../components/event/organisms/AtomLoading.vue";
import AtomFullPageLoader from "../components/global/atoms/AtomFullPageLoader.vue";

export default {
    name: 'PageVideos',
    components: {
      AtomFullPageLoader,
        AtomLoading,
        TransitionFade,
        OrganismVideosAllVideos, OrganismVideosProductions, OrganismVideosHero, LayoutDefault},
    data(){
        return {
            load: false
        }
    },
    methods: {
        ...mapActions('video', {
            searchVideos: 'search'
        }),
    },
    computed: {
        ...mapState("video", {
            videos: "videos",
        }),
    },
    mounted() {
        if (this.videos.length === 0){
            this.load = true;
            this.searchVideos({query: ''}).then(response => {
                setTimeout(() => {
                    this.load = false;
                }, 500);
            })
        }
    }
}
</script>
